export default __webpack_public_path__ + "static/IN-8015_16mm_lense_day_zoom-94753185e9f08152c3de4a5130c56da9.webp";